var Listeners = {};
var crossDocumentProtocol = {
  send: function send(targetWindow, event) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    try {
      var dataToSend = JSON.parse(JSON.stringify(data));
      targetWindow.postMessage({
        event: event,
        data: dataToSend
      }, '*');
    } catch (err) {
      console.error(err);
    }
  },
  on: function on(targetWindow, eventName, cb) {
    try {
      var listener = function listener(event) {
        if (event.data.event === eventName) cb(event.data.data);
      };

      Listeners[eventName] = Listeners[eventName] || [];
      Listeners[eventName].push(listener);
      targetWindow.addEventListener('message', listener, false);
    } catch (err) {
      console.error(err);
    }
  },
  off: function off(targetWindow, eventName) {
    try {
      if (Listeners[eventName]) {
        Listeners[eventName].map(function (cb) {
          targetWindow.removeEventListener('message', cb, false);
        });
        delete Listeners[eventName];
      }
    } catch (err) {
      console.error(err);
    }
  }
};
export default crossDocumentProtocol;